import Vue from "vue";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import Message from "element-ui/lib/message";
// import MessageBox from "element-ui/lib/message-box";
// import Notification from "element-ui/lib/notification";
// import DatePicker from "element-ui/lib/date-picker";
// import TimePicker from "element-ui/lib/time-picker";
// import TimeSelect from "element-ui/lib/time-select";
// import Table from "element-ui/lib/table";
// import TableColumn from "element-ui/lib/table-column";
// import Switch from "element-ui/lib/switch";
// import Tab from "element-ui/lib/tabs";
// import TabPane from "element-ui/lib/tab-pane";
// import Select from "element-ui/lib/select";
// import Option from "element-ui/lib/option";
// import Pagination from "element-ui/lib/pagination";
// import Tree from "element-ui/lib/tree";
// import InputNumber from "element-ui/lib/input-number";
// import Autocomplete from "element-ui/lib/autocomplete";
// import CheckboxGroup from "element-ui/lib/checkbox-group";
// import Input from "element-ui/lib/input";
// import Checkbox from "element-ui/lib/checkbox";
// import Dialog from "element-ui/lib/dialog";
// import Form from "element-ui/lib/form";
// import FormItem from "element-ui/lib/form-item";
// import Dropdown from "element-ui/lib/dropdown";
// import DropdownMenu from "element-ui/lib/dropdown-menu";
// import DropdownItem from "element-ui/lib/dropdown-item";
// import Menu from "element-ui/lib/menu";
// import MenuItem from "element-ui/lib/menu-item";
// import Submenu from "element-ui/lib/submenu";
// import Popover from "element-ui/lib/popover";
// import Carousel from "element-ui/lib/carousel";
// import CarouselItem from "element-ui/lib/carousel-item";
// import Radio from "element-ui/lib/radio";
// import Card from 'element-ui/lib/card';
// import Collapse from "element-ui/lib/collapse";
// import CollapseItem from "element-ui/lib/collapse-item";
// import Button from "element-ui/lib/button";
// import Tooltip from "element-ui/lib/tooltip";
// import Cascader from "element-ui/lib/cascader";
// import RadioGroup from "element-ui/lib/radio-group";
// import RadioButton from "element-ui/lib/radio-button";

import VueAreaLinkage from 'vue-area-linkage';
// import Upload from "element-ui/lib/upload";
// import PhotoPreview from "vue-photo-preview";
// import Loading from "element-ui/lib/loading";
// import Popconfirm from "element-ui/lib/popconfirm";
// import Progress from "element-ui/lib/progress";
// import image from "element-ui/lib/image"

/**
 * 布局 begin
 */
// import Container from "element-ui/lib/container";
// import Header from "element-ui/lib/header";
// import Aside from "element-ui/lib/aside";
// import Main from "element-ui/lib/main";
// import Footer from "element-ui/lib/footer";
/**
 * 布局 end
 */

import Treeselect from '@riophae/vue-treeselect';
// import 'element-ui/lib/theme-chalk/message.css';
// import "element-ui/lib/theme-chalk/message-box.css";
// import 'element-ui/lib/theme-chalk/notification.css';
// import 'element-ui/lib/theme-chalk/date-picker.css';
// import 'element-ui/lib/theme-chalk/time-picker.css';
// import 'element-ui/lib/theme-chalk/time-select.css';
// import 'element-ui/lib/theme-chalk/table.css';
// import 'element-ui/lib/theme-chalk/table-column.css';
// import 'element-ui/lib/theme-chalk/switch.css';
// import 'element-ui/lib/theme-chalk/tabs.css';
// import 'element-ui/lib/theme-chalk/tab-pane.css';
// import 'element-ui/lib/theme-chalk/pagination.css';
// import 'element-ui/lib/theme-chalk/select.css';
// import 'element-ui/lib/theme-chalk/tree.css';
// import 'element-ui/lib/theme-chalk/input-number.css';
// import 'element-ui/lib/theme-chalk/autocomplete.css';
// import 'element-ui/lib/theme-chalk/input.css';
// import 'element-ui/lib/theme-chalk/checkbox.css';
// import "element-ui/lib/theme-chalk/dialog.css";
// import "element-ui/lib/theme-chalk/form.css";
// import "element-ui/lib/theme-chalk/form-item.css";
// import 'element-ui/lib/theme-chalk/dropdown.css';
// import 'element-ui/lib/theme-chalk/dropdown-menu.css';
// import 'element-ui/lib/theme-chalk/dropdown-item.css';
// import 'element-ui/lib/theme-chalk/menu.css';
// import 'element-ui/lib/theme-chalk/menu-item.css';
// import 'element-ui/lib/theme-chalk/submenu.css';
// import 'element-ui/lib/theme-chalk/loading.css';
// import 'element-ui/lib/theme-chalk/popover.css';
// import 'element-ui/lib/theme-chalk/carousel.css';
// import 'element-ui/lib/theme-chalk/carousel-item.css';
// import 'element-ui/lib/theme-chalk/collapse.css';
// import 'element-ui/lib/theme-chalk/collapse-item.css';
// import 'element-ui/lib/theme-chalk/radio.css';
// import 'element-ui/lib/theme-chalk/card.css';
// import 'vue-area-linkage/dist/index.css';
// import 'element-ui/lib/theme-chalk/upload.css';
// import 'vue-photo-preview/dist/skin.css';
// import 'element-ui/lib/theme-chalk/button.css';
// import 'element-ui/lib/theme-chalk/tooltip.css';
// import 'element-ui/lib/theme-chalk/cascader.css';
// import 'element-ui/lib/theme-chalk/radio-group.css';
// import 'element-ui/lib/theme-chalk/radio-button.css';
// import 'element-ui/lib/theme-chalk/progress.css';
// import 'element-ui/lib/theme-chalk/image.css';
/**
 * 布局 begin
 */
// import 'element-ui/lib/theme-chalk/container.css';
// import 'element-ui/lib/theme-chalk/header.css';
// import 'element-ui/lib/theme-chalk/aside.css';
// import 'element-ui/lib/theme-chalk/main.css';
// import 'element-ui/lib/theme-chalk/footer.css';
/**
 * 布局 end
 */
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

// 字段配置组件
import TableFieldConfig from './components/common/TableFieldConfig.vue'

// Vue.prototype.$message = ElementUI.Message;
// Vue.prototype.$alert = ElementUI.MessageBox.alert;
// Vue.prototype.$prompt = ElementUI.MessageBox.prompt;
// Vue.prototype.$confirm = ElementUI.MessageBox.confirm;
// Vue.prototype.$notify = ElementUI.Notification;
// DatePicker.install(Vue);
// TimePicker.install(Vue);
// TimeSelect.install(Vue);
// Switch.install(Vue);
// Tab.install(Vue);
// TabPane.install(Vue);
// Table.install(Vue);
// TableColumn.install(Vue);
// Pagination.install(Vue);
// Select.install(Vue);
// Tree.install(Vue);
// Option.install(Vue);
// InputNumber.install(Vue);
// Autocomplete.install(Vue)
// CheckboxGroup.install(Vue);
// Input.install(Vue);
// Checkbox.install(Vue);
// Dialog.install(Vue);
// Form.install(Vue);
// FormItem.install(Vue);
// Dropdown.install(Vue);
// DropdownMenu.install(Vue);
// DropdownItem.install(Vue);
// Menu.install(Vue);
// MenuItem.install(Vue);
// Submenu.install(Vue);
// Popover.install(Vue);
// Carousel.install(Vue);
// CarouselItem.install(Vue);
// Radio.install(Vue);
// Card.install(Vue);
// Collapse.install(Vue);
// CollapseItem.install(Vue);
// Upload.install(Vue);
// Button.install(Vue);
// Tooltip.install(Vue);
// Cascader.install(Vue);
// RadioGroup.install(Vue);
// RadioButton.install(Vue);
// Loading.install(Vue);
// Popconfirm.install(Vue);
// Progress.install(Vue);
// image.install(Vue)
// Vue.use(PhotoPreview)
/**
 * 布局 begin
 */
// Container.install(Vue);
// Header.install(Vue);
// Main.install(Vue);
// Footer.install(Vue);
// Aside.install(Vue);

Vue.use(ElementUI);

Vue.use(VueAreaLinkage);
Vue.component("tree-select", Vue.extend(extend(Treeselect)));

Vue.component('TableFieldConfig', TableFieldConfig)

function extend(Treeselect) {
  const UNCHECKED = 0;
  const props = Treeselect.mixins[0].props;
  const methods = Treeselect.mixins[0].methods;
  props.noResultsText.default = "暂无数据";
  props.noOptionsText.default = "暂无数据";
  props.loadingText.default = "加载中……";
  const oldCreateFallbackNode = methods.createFallbackNode;

  methods.createFallbackNode = function createFallbackNode(id) {
    const result = oldCreateFallbackNode.apply(this, arguments);
    var raw = this.extractNodeFromValue(id);
    result.label = this.enhancedNormalizer(raw).label || id + "";
    return result;
  };
  methods.select = function(node) {
    this.$emit("item-click", node);
    if (this.disabled || node.isDisabled) {
      return;
    }

    if (this.single) {
      this.clear();
    }

    const nextState =
      this.multiple && !this.flat
        ? this.forest.checkedStateMap[node.id] === UNCHECKED
        : !this.isSelected(node);

    if (nextState) {
      this._selectNode(node);
    } else {
      this._deselectNode(node);
    }

    this.buildForestState();

    if (nextState) {
      this.$emit("select", node.raw, this.getInstanceId());
    } else {
      this.$emit("deselect", node.raw, this.getInstanceId());
    }

    if (
      this.localSearch.active &&
      nextState &&
      (this.single || this.clearOnSelect)
    ) {
      this.resetSearchQuery();
    }

    if (this.single && this.closeOnSelect) {
      this.closeMenu();

      // istanbul ignore else
      if (this.searchable) {
        this._blurOnSelect = true;
      }
    }
  };
  return Treeselect;
}
